import { HttpClient } from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';

import { AuthQuery } from '@23degrees/stores/auth/auth.query';
import { version } from '@app/version';
import { DOCUMENT, LocationStrategy, PathLocationStrategy } from '@angular/common';

// http://jsfiddle.net/kein1945/M9K2c/
// https://gist.github.com/eladkarako/738ff6791dd2e44baeb5787851f874d5
// https://github.com/danang-id/simple-crypto-js
const xor = (text, shift = 13) => {
  return String.fromCharCode(...text.split('').map((char) => char.charCodeAt() ^ shift));
};

// Uncaught (in promise): NotSupportedError: Failed to register a ServiceWorker: The user denied permission to use Service Worker.
// Uncaught (in promise): Error: Loading chunk 0 failed.
// Uncaught (in promise): SecurityError: The operation is insecure.
// Uncaught (in promise): NotSupportedError
// Cannot call method 'trim' of undefined         https://github.com/angular/angular/issues/24094
// Cannot read property 'split' of undefined      https://github.com/angular/angular/issues/24094
// ViewDestroyedError: Attempt to use a destroyed view: detectChanges

// ERROR TypeError: Das Objekt unterstützt die Eigenschaft oder Methode "fill" nicht
// Object doesn't support property or method 'fill'
// new Int32Array(this._hashSize).fill is not a function. (In 'new Int32Array(this._hashSize).fill(-1)', 'new Int32Array(this._hashSize).fill' is undefined)
// TypeError: Die Eigenschaft "split" eines undefinierten oder Nullverweises kann nicht abgerufen werden

// error: 'undefined' is not an object (evaluating 'ln(e,"").trim')

/*

IE11 unfixable shit

"TypeError: Das Objekt unterstützt die Eigenschaft oder Methode "fill" nicht
   at e (https://doh.23degrees.io/bundle/main-es5.775850f5e1f9060d4cf0.js:1:1751837)
   at e (https://doh.23degrees.io/bundle/main-es5.775850f5e1f9060d4cf0.js:1:1766329)
   at value (https://doh.23degrees.io/bundle/main-es5.775850f5e1f9060d4cf0.js:1:1766711)
   at l.renderLine (https://doh.23degrees.io/bundle/main-es5.775850f5e1f9060d4cf0.js:1:1819964)
   at l.renderChart (https://doh.23degrees.io/bundle/main-es5.775850f5e1f9060d4cf0.js:1:1789014)
   at l.updateChart (https://doh.23degrees.io/bundle/main-es5.775850f5e1f9060d4cf0.js:1:1783014)
   at i.updateChartSize (https://doh.23degrees.io/bundle/8-es5.eab253b48af71a4b60f2.js:1:245217)
   at i.receiveLayoutReady (https://doh.23degrees.io/bundle/8-es5.eab253b48af71a4b60f2.js:1:244640)
   at Anonymous function (https://doh.23degrees.io/bundle/main-es5.775850f5e1f9060d4cf0.js:1:415334)
   at value (https://doh.23degrees.io/bundle/main-es5.775850f5e1f9060d4cf0.js:1:97441)"
*/

@Injectable({ providedIn: 'root' })
export class ErrorService {
  private injector = inject(Injector);
  private notificationService = inject(NotificationsService);
  private authQuery = inject(AuthQuery);
  private httpClient = inject(HttpClient);
  private document = inject<Document>(DOCUMENT);

  private LOG_PATH = '/services/log';

  private knownErrors = [
    'ViewDestroyedError',
    'NotSupportedError',
    'Error: Loading chunk',
    'ExpressionChangedAfterItHasBeenCheckedError',
    'SecurityError: The operation is insecure',
    "Cannot call method 'trim' of undefined",
    "Cannot read property 'split' of undefined",
  ];

  clientError = async (error: Error) => {
    // only log if we are in production
    // if (!environment.production) return;

    try {
      if (this.shouldSkipError(error)) return;

      const win: any = window || {};
      const doc: any = this.document || {};
      const nav: any = navigator || {};

      const versionHash = `#${version.revision.substring(0, 7)}`;
      const versionDate = new Date(version.date).toLocaleDateString('de-DE');

      const width = win.innerWidth || doc.body.clientWidth;
      const height = win.innerHeight || doc.body.clientHeight;

      let location = win.location.href;
      if (win.getInjectedContent) {
        const content = await win.getInjectedContent();
        location = `${location}/${content.slug}`;
      }

      if (win.contentSlug) {
        location = `${location}/${win.contentSlug}`;
      }

      const message = {
        error: {
          name: error.name,
          stack: error.stack,
          message: error.message,
          fileName: (error as any).fileName,
          lineNumber: (error as any).lineNumber,
          columnNumber: (error as any).columnNumber,
        },
        versionDate: versionDate,
        versionHash: versionHash,
        cookieEnabled: nav.cookieEnabled,
        platform: nav.platform,
        userAgent: nav.userAgent,
        location: location,
        width: width,
        height: height,
      };

      console.log({ message });

      const msgStr = JSON.stringify(message);
      const msgXor = xor(msgStr, 23);

      const res = await this.httpClient.post(`${this.LOG_PATH}/error`, { message: msgXor }).toPromise();
    } catch (err) {
      // do nothing
    }
  };

  unauthorizedUser = (error) => {
    if (this.authQuery.isLoggedIn()) {
      this.notificationService.error('Not authorized', `You can't do this, want to upgrade?`);
    } else if (this.authQuery.isAnonUser()) {
      this.notificationService.error('Not authorized', `You're not logged in, wanna login?'`);
      console.log('[errorService][unauthorizedUser]', 'isAnonUser');
    }
  };

  serverError = (error) => {
    if (error.error?.message) {
      this.notificationService.error('Error', error.error.message);
    } else {
      this.notificationService.error('Server Error', `The Server responded with ${error.status}`);
    }
  };

  offlineError = (error) => {
    this.notificationService.error('Offline', 'Cannot reach server, please check your connection');
  };

  ssrError = (error) => {
    const location = this.injector.get(LocationStrategy);
    const url = location instanceof PathLocationStrategy ? location.path() : '';
    console.error('[ErrorService] SSR ERROR:', url, error);
  };

  shouldSkipError(error) {
    let skipLog = false;
    for (const str of this.knownErrors) {
      if (error.message.includes(str)) {
        skipLog = true;
      }
    }

    if (skipLog) return true;
    if (this.knownErrors.includes(error.name)) return true;
    if (error.name === 'TypeError' && error.message.includes('fill')) return true;

    return false;
  }
}
